module.exports = __webpack_public_path__ + "img/Noctiluca-Inspect-Portrait.4bc00c2a.png";